import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ZzzConfigService } from 'src/app/zzz/core/config/config.service';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocumentService {
  private urlApi: string;

  constructor(
    private configService: ZzzConfigService,
    private http: HttpClient
  ) {
    this.urlApi = this.configService.get().authApiEndPoint;
  }

  // TODO: lorsqu'on aura un reverse proxy qui permetra de ne pas écrire les adresses complètes (à cause des paliers) on pourra
  // supprimer cette méthode et l'appelante et utiliser directement le lien dans fr.json comme cela:
  // 'Veuillez <a href="/sigtapi/document-pdf/nom-du-pdf.pdf" target="_blank">consultez ce guide</a> pour obtenir ...'
  getPdf(fileName: string): Observable<Blob> {
    const url = `${this.urlApi}/sigtapi/document-pdf/${fileName}`;
    return this.http.get(url, {
      responseType: 'blob'
    });
  }
}
